module.exports = __webpack_public_path__ + "static/filborg-1-e7b163106bf497a0a2f72ccc9fed8afa.jpg";